import { TableColumn } from "../../types/table-column";

export const usersColumns: TableColumn[] = [
  // {
  //   type: "checkbox",
  //   fieldName: "checkbox",
  //   value: "id",
  //   width: 2,
  // },
  {
    type: "client",
    fieldName: "PERSON",
    value: "name",
    secondaryValue: "email",
    width: 18,
    hasSorting: true,
  },
  {
    type: "string",
    fieldName: "COMPANY",
    value: "company",
    width: 15,
    hasSorting: true,
  },
  {
    type: "role",
    fieldName: "ROLE",
    value: "role",
    secondaryValue: "group",
    width: 10,
    hasSorting: false,
  },
  {
    type: "string",
    fieldName: "SUBSCRIPTION",
    value: "subscription",
    width: 8,
    hasSorting: true,
  },
  {
    type: "projects",
    fieldName: "PROJECTS",
    value: "projects",
    width: 10,
    hasSorting: false,
  },
  {
    type: "date",
    fieldName: "INVITED",
    value: "created_at",
    width: 10,
    hasSorting: true,
  },
  {
    type: "date",
    fieldName: "APPROVED",
    value: "invited_at",
    width: 10,
    hasSorting: true,
  },
  {
    type: "date",
    fieldName: "EXPIRATION",
    value: "end_subscription_at",
    width: 10,
    hasSorting: true,
  },
  {
    type: "status",
    fieldName: "STATUS",
    value: "status",
    width: 10,
    hasSorting: true,
  },
  {
    type: "actions",
    fieldName: "",
    value: "users",
    width: 1,
  },
];
